import api from '../lib/axios';
export async function login(email, password) {
    const { data } = await api.post('/api/v1/auth/login', { username: email, password });
    return data;
}
export async function refreshToken(token) {
    const { data } = await api.post('/api/v1/auth/refresh', { refresh_token: token });
    return data;
}
export async function getMe() {
    const { data } = await api.get('/api/v1/auth/me');
    return data;
}
/** Envoie un code à 6 chiffres par email (même API que l'application mobile). */
export async function forgotPassword(email) {
    await api.post('/api/v1/auth/forgot-password', { email });
}
export async function resetPassword(email, code, newPassword) {
    await api.post('/api/v1/auth/reset-password', { email, code, new_password: newPassword });
}
